
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Mumbaiairporttopunecab() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Pune Cab',
        heading: 'Meghana Cab : Mumbai Airport to Pune Cab',
        headingDescription: 'Meghana Cab offers Mumbai Airport to Pune Cab services, ensuring a smooth and timely transfer from Chhatrapati Shivaji Maharaj International Airport to your destination in Pune. Whether you are arriving late at night or during peak hours, our professional drivers and well-maintained cabs provide a safe, comfortable, and stress-free journey. Enjoy fixed pricing, real-time tracking, and 24/7 customer support. Book your Mumbai Airport to Pune Cab with Meghana Cab and experience hassle-free airport travel with reliability and convenience.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "A historical fortification built in 1732, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. The grand gateway, expansive ruins, and the evening light and sound show depicting Maratha history make it one of Pune’s most important landmarks for cultural and heritage tourism."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, the Aga Khan Palace holds deep significance in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi. The palace is surrounded by lush gardens and houses a museum with Gandhian artifacts and personal belongings."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, this fort is a popular destination for trekking and history lovers. It was the site of the Battle of Sinhagad in 1670, and offers panoramic views of the surrounding valleys. Visitors also enjoy local food like pithla bhakri at the summit."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum showcases over 20,000 artifacts including musical instruments, traditional utensils, sculptures, and textiles. It offers a glimpse into India’s rich artistic and cultural history, particularly from Maharashtra."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple located in the heart of the city, Pataleshwar is dedicated to Lord Shiva. It features a circular Nandi mandapa and intricately carved pillars. The temple is a peaceful heritage site amidst urban surroundings."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Situated in Koregaon Park, this globally renowned spiritual retreat attracts visitors interested in meditation, wellness, and holistic healing. The campus offers a tranquil setting with daily meditation sessions and therapy workshops."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend getaway for Pune residents, this dam provides water to the city and is surrounded by scenic views of hills and greenery. It's ideal for picnics, photography, and relaxing by the water during early mornings or evenings."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by a Japanese garden in Okayama, this beautifully landscaped public park features manicured lawns, flowing streams, and charming bridges. It's a favorite spot for family outings and peaceful strolls."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shivaji Maharaj’s father, Shahaji, this reconstructed palace commemorates the early life of Chhatrapati Shivaji Maharaj. It houses paintings, artifacts, and replicas reflecting Maratha heritage."
  },
  {
    "title": "Fergusson College Road",
    "description": "Known for its lively ambiance and youthful vibe, this road is a hub for students, with a wide variety of cafes, bookstores, fashion outlets, and street food. It reflects the cultural vibrancy and modern spirit of Pune."
  }
],

"services": [
    {
        "name": "Book Cab Mumbai Airport to Pune",
        "description": "Easily book a cab from Mumbai Airport to Pune with Meghana Cab. Our airport pickup services ensure comfort, punctuality, and a smooth journey right from your terminal to your doorstep in Pune. Enjoy professional service with experienced chauffeurs and clean, well-maintained vehicles."
    },
    {
        "name": "Pickup from Mumbai Airport to Pune",
        "description": "Get hassle-free pickup from Mumbai Airport to Pune with Meghana Cab. Our drivers track your flight for on-time arrival and assist with your luggage. Whether you arrive at the domestic or international terminal, your cab will be ready for a seamless transfer to Pune."
    },
    {
        "name": "Airport to Home Pune Taxi Service",
        "description": "Meghana Cab offers personalized taxi service from Mumbai Airport directly to your home in Pune. Avoid the rush and travel in peace with our door-to-door transfers, available 24/7 with comfortable seating and professional drivers."
    },
    {
        "name": "Mumbai International Airport to Pune Cab",
        "description": "Arriving at Mumbai International Airport? Book your cab to Pune in advance with Meghana Cab. Our international terminal pickups are handled by trained drivers who ensure timely and comfortable travel to your Pune destination, with zero stress after a long flight."
    },
    {
        "name": "Affordable Taxi Mumbai Airport to Pune",
        "description": "Get affordable taxi fares from Mumbai Airport to Pune without compromising quality. Meghana Cab offers cost-effective solutions for one-way or round-trip airport transfers with transparent pricing and no hidden charges."
    },
    {
        "name": "AC Cab Hire Mumbai Airport to Pune",
        "description": "Travel in comfort with our air-conditioned cabs from Mumbai Airport to Pune. Our fleet includes sedans, SUVs, and premium cars, all equipped with AC for a relaxing journey, especially during long-distance travel or in hot weather."
    },
    {
        "name": "24/7 Airport Pickup to Pune",
        "description": "No matter what time your flight lands, Meghana Cab provides round-the-clock pickup services from Mumbai Airport to Pune. With 24/7 customer support and real-time driver tracking, we ensure reliable service at all hours."
    },
    {
        "name": "SUV Cab from Mumbai Airport to Pune",
        "description": "Need extra space or traveling with a group? Book an SUV cab from Mumbai Airport to Pune with Meghana Cab. Our spacious SUVs offer comfortable legroom and luggage space, ideal for families or travelers with heavy bags."
    },
    {
        "name": "One Way Airport Taxi to Pune",
        "description": "Book a one-way taxi from Mumbai Airport to Pune with Meghana Cab for quick, efficient transfers. This is a perfect solution for business travelers, tourists, or locals looking for a reliable and cost-effective one-time ride."
    },
    {
        "name": "Private Transfer Mumbai Airport to Pune",
        "description": "Enjoy privacy and convenience with Meghana Cab's private transfer service from Mumbai Airport to Pune. Avoid shared rides or delays with our exclusive cabs offering direct service to your Pune destination."
    },
    {
        "name": "Mumbai to Pune Airport Taxi Fare",
        "description": "Curious about the cost? Meghana Cab offers competitive and transparent taxi fares for transfers from Mumbai Airport to Pune. Check exact pricing during booking and enjoy fixed rates with no last-minute surprises."
    },
    {
        "name": "Timely Pickup Mumbai Airport to Pune",
        "description": "Time is valuable, and Meghana Cab ensures timely pickup at Mumbai Airport for your Pune trip. We monitor flight arrivals and guarantee prompt driver arrival so you never have to wait or delay your journey."
    },
    {
        "name": "Luxury Airport Cab to Pune",
        "description": "Upgrade your travel with Meghana Cab's luxury cab options from Mumbai Airport to Pune. Our premium vehicles feature plush interiors, bottled water, and elite chauffeur service, ideal for VIPs, executives, or special occasions."
    },
    {
        "name": "Sedan Cab Mumbai Airport to Pune",
        "description": "Choose a sedan cab from Mumbai Airport to Pune for a comfortable, efficient, and affordable ride. Our sedans are perfect for solo travelers or small families looking for a smooth and stylish transfer."
    },
    {
        "name": "Online Booking Airport Taxi to Pune",
        "description": "With Meghana Cab, you can easily book your airport taxi to Pune online in just a few clicks. Select your vehicle, schedule your pickup, and confirm instantly with our user-friendly platform and 24/7 support."
    }
],

"tableData": [
    ["Book Cab Mumbai Airport to Pune", "Pickup from Mumbai Airport to Pune"],
    ["Airport to Home Pune Taxi Service", "Mumbai International Airport to Pune Cab"],
    ["Affordable Taxi Mumbai Airport to Pune", "AC Cab Hire Mumbai Airport to Pune"],
    ["24/7 Airport Pickup to Pune", "SUV Cab from Mumbai Airport to Pune"],
    ["One Way Airport Taxi to Pune", "Private Transfer Mumbai Airport to Pune"],
    ["Mumbai to Pune Airport Taxi Fare", "Timely Pickup Mumbai Airport to Pune"],
    ["Luxury Airport Cab to Pune", "Sedan Cab Mumbai Airport to Pune"],
    ["Online Booking Airport Taxi to Pune", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Convenient Mumbai Airport to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a smooth, door-to-door cab service from Mumbai Airport to Pune, eliminating the stress of public transport or long waits. Whether you’re arriving on a domestic or international flight, we ensure a prompt pickup and a comfortable ride home or to your hotel."
    },
    {
        "WhyChooseheading": "Timely Airport Pickup with Flight Tracking",
        "WhyChoosedescription": "We track your flight in real-time to ensure your cab is waiting when you land. Our professional drivers handle airport pickups efficiently, helping with luggage and guiding you to your cab for a swift exit from the terminal."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Meghana Cab vehicles are air-conditioned, regularly cleaned, and sanitized. Whether you choose a sedan, SUV, or premium car, you'll enjoy a relaxing and spacious ride from Mumbai Airport to Pune."
    },
    {
        "WhyChooseheading": "Affordable, Transparent Fare Structure",
        "WhyChoosedescription": "Our pricing is upfront and clear. You’ll get competitive fares with no hidden costs, tolls, or surprises, making your Mumbai Airport to Pune journey budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Availability for Any Flight Schedule",
        "WhyChoosedescription": "Whether your flight lands at 3 AM or 11 PM, our Mumbai Airport to Pune cab service is available round-the-clock to serve your travel needs anytime, day or night."
    },
    {
        "WhyChooseheading": "Experienced Drivers Who Know the Route",
        "WhyChoosedescription": "Our drivers are trained and experienced in airport transfers and familiar with the Mumbai–Pune Expressway. They ensure a safe, efficient, and smooth journey, even during late hours or peak traffic."
    },
    {
        "WhyChooseheading": "Flexible Drop-off Locations Across Pune",
        "WhyChoosedescription": "Whether you're heading to Baner, Hinjewadi, Kothrud, Hadapsar, or anywhere in Pune, we provide flexible drop-off options to get you exactly where you need to be—comfortably and on time."
    },
    {
        "WhyChooseheading": "Simple Booking and 24x7 Customer Support",
        "WhyChoosedescription": "Book your Mumbai Airport to Pune cab easily via our app, website, or phone. Our support team is available 24/7 to assist with bookings, changes, or any special requests."
    }
]





































    }

const faqData = [
    {
        question: "How can I book a cab from Mumbai Airport to Pune with Meghana Cab?",
        answer: "You can book a Mumbai Airport to Pune cab by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "Do you provide timely pickups from Mumbai Airport to Pune?",
        answer: "Yes, our drivers track your flight timings to ensure timely pickups from Mumbai Airport to Pune."
    },
    {
        question: "What types of vehicles are available for Mumbai Airport to Pune trips?",
        answer: "We offer sedans, SUVs, and tempo travellers depending on your group size and luggage."
    },
    {
        question: "Can I book a one-way or round-trip cab from Mumbai Airport to Pune?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip services for Mumbai Airport to Pune transfers."
    },
    {
        question: "Is Meghana Cab available 24/7 for Mumbai Airport to Pune bookings?",
        answer: "Yes, our service is available round-the-clock to accommodate your flight schedules."
    },
    {
        question: "Are the vehicles sanitized and safe for travel?",
        answer: "All vehicles are regularly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        question: "What is included in the Mumbai Airport to Pune cab fare?",
        answer: "The fare covers driver charges, fuel, and vehicle maintenance. Additional charges like tolls may apply."
    },
    {
        question: "What payment methods are accepted for Mumbai Airport to Pune cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "Can Meghana Cab accommodate large groups from Mumbai Airport to Pune?",
        answer: "Yes, we offer tempo travellers and SUVs for larger groups and luggage."
    },
    {
        question: "How can I contact Meghana Cab for Mumbai Airport to Pune cab service?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Mumbai Airport to Pune cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Vinay Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided an excellent Mumbai Airport to Pune cab service. The driver was punctual and courteous.”',
    },
    {
        name: 'Ms. Sneha Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a smooth and comfortable ride from Mumbai Airport to Pune with Meghana Cab. Highly recommended!”',
    },
];































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cab",
  "image": "https://www.meghanacabs.com/assets/images/mumbai-airport-to-pune-cab.jpg",
  "description": "Book Mumbai Airport to Pune cab with Meghana Cabs for reliable and affordable airport transfers. Enjoy timely pickup, AC sedans/SUVs, and 24/7 private cab service to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5673"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/mumbai-airport-to-pune-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai Airport to Pune Cab | 24/7 Pickup & Affordable Fare | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune cab with Meghana Cabs for reliable and affordable airport transfers. Enjoy timely pickup, AC sedans/SUVs, and 24/7 private cab service to Pune." 
  />
  <meta 
    name="keywords" 
    content="Book Cab Mumbai Airport to Pune, Pickup from Mumbai Airport to Pune, Airport to Home Pune Taxi Service, Mumbai International Airport to Pune Cab, Affordable Taxi Mumbai Airport to Pune, AC Cab Hire Mumbai Airport to Pune, 24/7 Airport Pickup to Pune, SUV Cab from Mumbai Airport to Pune, One Way Airport Taxi to Pune, Private Transfer Mumbai Airport to Pune, Mumbai to Pune Airport Taxi Fare, Timely Pickup Mumbai Airport to Pune, Luxury Airport Cab to Pune, Sedan Cab Mumbai Airport to Pune, Online Booking Airport Taxi to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttopunecab;